// extracted by mini-css-extract-plugin
export default {"wrapper":"NavBalanceCurrencyWrapper_wrapper__B5uCT"};